export default __webpack_public_path__ + "static/OYOY-1680x340-60fps-9fcf3b7ee04e1e0a87e9900bc0dbc2eb.mp4";